<template>
  <j-modal
    centered
    :width="700"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <template slot="title">
      <span>{{ parentData.realname }}</span>
    </template>

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-descriptions class="no-label">
        <a-descriptions-item>
          <a-table tableLayout="fixed" :pagination="false" bordered :dataSource="form.relations">
            <a-table-column key="departId" data-index="departId" align="left" class="after">
              <span slot="title" class="required">部门</span>
              <template slot-scope="text, record, index">
                <a-form-model-item :prop="`relations.${index}.departId`">
                  <span>{{ $getDepartTree(record.departId).departName }}</span>
                </a-form-model-item>
              </template>
            </a-table-column>

            <a-table-column key="positionId" data-index="positionId" align="left">
              <span slot="title" :class="$isRequired('positionId')">职位</span>
              <template slot-scope="text, record, index">
                <a-form-model-item :prop="`relations.${index}.positionId`" :help="record.departIdHelp" :key="refresh">
                  <j-dict-select-tag v-model="record.positionId" placeholder="请选择职位" :dictCode="$getPosition()" />
                </a-form-model-item>
              </template>
            </a-table-column>

            <a-table-column key="bizLineId" data-index="bizLineId" align="left">
              <span slot="title" :class="$isRequired('bizLineId')">条线</span>
              <template slot-scope="text, record, index">
                <a-form-model-item :prop="`relations.${index}.bizLineId`">
                  <j-dict-select-tag v-model="record.bizLineId" placeholder="请选择条线" :dictCode="$getBizLine()" />
                </a-form-model-item>
              </template>
            </a-table-column>

            <a-table-column :width="46" align="center">
              <span slot="title">
                <i class="mdi mdi-plus" @click="addRow()"></i>
              </span>
              <div slot-scope="text, record, index" style="white-space: nowrap">
                <a @click="deleteRow(form.relations, index)">删除</a>
              </div>
            </a-table-column>
          </a-table>
        </a-descriptions-item>
      </a-descriptions>
    </a-form-model>
  </j-modal>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { tableMixin } from '@/mixins/tableMixin'

class formDef {
  relations = []
}

export default {
  name: 'EditRelation',
  mixins: [tableMixin],
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      form: new formDef(),
      parentData: {},
      loading: false,
      // 强制刷新用
      refresh: new Date().getTime(),
      url: {},
    }
  },
  watch: {
    'form.relations': {
      handler(newVal, oldVal) {
        this.form.relations.forEach((r, index) => {
          // 重复check
          if (
            XEUtils.filter(
              this.form.relations,
              (row) => row.departId == r.departId && row.positionId == r.positionId && row.bizLineId == r.bizLineId
            ).length > 1
          ) {
            r.departIdHelp = '已有相同的部门职位条线组合'
          } else {
            // 包含check
            if (
              r.departId &&
              !r.positionId &&
              !r.bizLineId &&
              XEUtils.filter(this.form.relations, (row) => row.departId == r.departId).length > 1
            ) {
              r.departIdHelp = '已被其他明细包含，请继续设置职位或条线'
            } else {
              r.departIdHelp = undefined
            }
          }

          this.refresh++
        })
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  methods: {
    handleOpen(parentData) {
      this.visible = true
      this.parentData = parentData
      this.form.relations = XEUtils.clone(parentData.relations, true)
    },
    handleOk() {
      // 表单验证
      this.$refs.form.validateFieldsAndScroll((ok) => {
        // 验证成功
        if (ok) {
          // 检查变更点
          if (this.form.relations.length == this.parentData.relations.length) {
            var isSame = true
            for (let index = 0; index < this.form.relations.length; index++) {
              const after = this.form.relations[index]
              if (
                XEUtils.filter(
                  this.parentData.relations,
                  (row) =>
                    row.departId == after.departId &&
                    row.positionId == after.positionId &&
                    row.bizLineId == after.bizLineId
                ).length == 0
              ) {
                isSame = false
                break
              }
            }

            // 无变更点，则直接关闭弹出框
            if (isSame) {
              this.visible = false
              return
            }
          }

          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          var url = '/blaze-sys/k00/k0014/UserManage/updateUserDepartPosition'
          if (this.parentData.changePlanId) {
            url = '/blaze-sys/k00/k0015/DepartAction/updateUserDepartPosition'
          }

          postAction(url, {
            changePlanId: this.parentData.changePlanId,
            id: this.parentData.id.split(';')[0],
            departId: this.parentData.departId,
            relations: this.form.relations,
          })
            .then((res) => {
              if (res.success) {
                this.$message.success('处理成功')
                this.visible = false
                this.$emit('emit')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    addRow() {
      this.form.relations.push({
        changePlanId: this.parentData.departId,
        userId: this.parentData.id.split(';')[0],
        departId: this.parentData.departId,
        positionId: undefined,
        bizLineId: undefined,
      })
    },
  },
}
</script>

<style scoped></style>
